import { useStore } from '../../../../hooks/useStore';
import { getScheduleEventsBySeason } from '../../../../store/schedule';
import { formatDate } from '../../../../utils/format';

interface ScheduleStepPickerProps {
  seasonId?: string;
  value: string;
  onChange: (scheduleEventId: string) => void;
}

/** Shows "which bước (step) of the season's cultivation process are you on"
 * and lets the farmer explicitly pick one to tag their log entry to.
 * Renders nothing at all when the season has no PLANNED/OVERDUE events —
 * i.e. no CultivationProcess was ever applied to it — so a standalone
 * farmer's log form looks exactly as it did before this component existed. */
export function ScheduleStepPicker({ seasonId, value, onChange }: ScheduleStepPickerProps) {
  useStore();
  const events = getScheduleEventsBySeason(seasonId).filter((e) => e.status === 'PLANNED' || e.status === 'OVERDUE');

  if (events.length === 0) return null;

  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1">Bước hiện tại của quy trình canh tác</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500"
      >
        <option value="">— Không gán vào bước nào —</option>
        {events.map((e) => (
          <option key={e._id} value={e._id}>
            {(e.note || e.eventType)} · {formatDate(e.plannedDate)}
            {e.status === 'OVERDUE' ? ' (quá hạn)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
